
<header id="main-header">
  <app-nav (onLogout)="onUserLogout()"> </app-nav>
  <app-search-small #searchSmall></app-search-small>
</header>
<div class="page-container"
     [ngClass.xs]="'page-c-mobile'"
     [ngClass.gt-xs]="'page-c-desktop'"
     [@routeAnimation]="getAnimationData(routerOutlet)">
  <router-outlet #routerOutlet="outlet"></router-outlet>
</div>


<div id="adLoader"></div>

<!--<div class="ads-box" id="ad1" [innerHTML]="ad1">

</div>
<div class="ads-box" id="ad2" [innerHTML]="ad2">
 
</div>
<div class="ads-box-mobile" id="ad2" [innerHTML]="ad3">
  
</div>-->


<div id="seo-text-wrapper">
  <app-seo-texts-wrapper></app-seo-texts-wrapper>
</div>

<div class="footer-bar">
  <div class="mt-2"></div>
  <app-footer></app-footer>
</div>

<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <mat-nav-list>
      <span (click)="sidenav.toggle()" href="" mat-list-item>Close</span>
      <a href="#" mat-list-item>Menu Item 1</a>
      <a href="#" mat-list-item>Menu Item 2</a>
      <a href="#" mat-list-item>Menu Item 3</a>
      <a href="#" mat-list-item>Menu Item 4</a>
      <a href="#" mat-list-item>Menu Item 5</a>
      <a href="#" mat-list-item>Menu Item 6</a>
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>


